import {Text} from '@mantine/core';
import {Account} from "../types.ts";
import {getUserNameInfo} from "../utils/userNameUtils.ts";

export const UserFullName = ({user}: { user: Account }) => {
    const {fullName} = getUserNameInfo(user);

    return <Text fw={800}>{fullName}</Text>;
};

